import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-secret-display-dialog',
  templateUrl: './secret-display-dialog.component.html',
  styleUrls: ['./secret-display-dialog.component.scss']
})
export class SecretDisplayDialogComponent implements OnInit {
  @Input() clientId: string = '';
  @Input() clientSecret: string = '';
  @Input() title: string = '';
  @Input() titleKey: string = 'DEV_CLIENTS.SECRET_DIALOG.CREATED_TITLE';

  tokenEndpoint = '';

  constructor(
    private dialogRef: NbDialogRef<SecretDisplayDialogComponent>,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    const base = environment.baseUrl.replace(/\/$/, '');
    this.tokenEndpoint = `${base}/oauth/token`;
  }

  dialogTitle(): string {
    return this.title || this.translate.instant(this.titleKey);
  }

  copyToClipboard(value: string, labelKey: string): void {
    navigator.clipboard.writeText(value).then(() => {
      this.toastr.success(this.translate.instant('DEV_CLIENTS.SECRET_DIALOG.COPIED', { label: this.translate.instant(labelKey) }));
    }).catch(() => {
      this.toastr.error(this.translate.instant('DEV_CLIENTS.SECRET_DIALOG.COPY_FAILED'));
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
